import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ssoLogin } from "../../Store/Actions/authActions";
import { login } from "../../Store/Actions/authActions";
import { useHistory } from "react-router-dom";
import { USER_SSO_RESET } from "../../Store/Constants/authConstants";
import { RESUME_CREATE_RESET } from "../../Store/Constants/ResumeConstants";
import {
  createResumes,
  sampleResumeById,
} from "../../Store/Actions/ResumeActions";
import { createCoverLetter } from "../../Store/Actions/CoverLetterActions";
import { COVER_CREATE_RESET } from "../../Store/Constants/CoverLetterConstants";

function SocialLogin(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const socialUrl = useSelector((state) => state.userSocial);
  const loadUserData = useSelector((state) => state.userData.userInfo);

  const editorData = useSelector((state) => state.editorData);
  const coverData = useSelector((state) => state.coverData);

  const create = useSelector((state) => state.createResume);
  const coverCreate = useSelector((state) => state.coverCreate);

  const { resume } = useSelector((state) => state.resumeGetById);
  const { coverLetter } = useSelector((state) => state.coverParticular);
  const path = window.location.pathname;
  const query = new URLSearchParams(window.location.search);
  const refer = query.get("refer");

  const socialLogin = (value) => {
    props.handlesocial(true);
    dispatch(ssoLogin(value));
  };

  const [externalPopup, setExternalPopup] = useState(null);

  useEffect(() => {
    if (socialUrl && socialUrl.social && socialUrl.social.url) {
      const width = 500;
      const height = 400;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2.5;
      const title = `WINDOW TITLE`;
      const url = socialUrl.social.url;
      window.addEventListener("message", handler, false);
      setTimeout(function () {
        const popup = window.open(
          url,
          "_self"
          // "location=yes,height=570,width=520,scrollbars=yes,status=yes"
        );
        setExternalPopup(popup);
      }, 100);

      dispatch({ type: USER_SSO_RESET });
    }
  }, [socialUrl]);

  const [content, setContent] = useState({
    title: "Untitled",
    thumb: "",
    type: "resume",
    content: JSON.stringify(props.resumeFields),
    isLetter: 0,
    completed: false,
    template_id: resume && resume.template_id,
  });

  const [coverContent, setCoverContent] = useState({
    title: "Untitled",
    thumb: "",
    type: "cover_letter",
    content: JSON.stringify(coverData),
    isLetter: 0,
    completed: false,
    template_id: coverLetter && coverLetter.template_id,
  });

  useEffect(() => {
    if (loadUserData && loadUserData.token) {
      props.handlesocial(false);
      if (!props.admin) {
        if (props && props.isModal) {
          if (props && props.social) {
            if (path && path.includes("create-cover")) {
              dispatch(createCoverLetter(coverContent));
            } else {
              dispatch(createResumes(content));
            }
          }
        } else {
          const localSampleId = localStorage.getItem("sample_id");

          if (localSampleId && localSampleId != "") {
            history.push(
              `/create-resume/sample/${localSampleId}/?refer=resume-samples`
            );
          } else {
            history.push("/home");
          }
        }
      } else {
        history.push("/admin/dashboard");
      }
    }
  }, [loadUserData]);

  const handler = (event) => {
    if (event && event.data && event.data.length > 0) {
      window.removeEventListener("message", handler);
      dispatch(login(event.data[1], event.data[0], "google", refer));
    }
  };

  useEffect(() => {
    if (
      create &&
      create.create &&
      create.create.type &&
      create.create.type === "resume"
    ) {
      history.push(`/resumes/${create.create.id}`);
      dispatch({ type: RESUME_CREATE_RESET });
    }
  }, [create]);

  return (
    <div className="row">
      <input type="hidden" id="archiveimages"></input>
      <div className="col-lg-4 col-md-12">
        <a
          onClick={() => socialLogin("google")}
          className="btn socialbtn w-100"
        >
          <img src="/images/google.svg" alt="google" className="loginlogos" />
          Google
        </a>
      </div>
      <div className="col-lg-4 col-md-12">
        <a
          onClick={() => socialLogin("facebook")}
          className="btn socialbtn w-100 "
        >
          <img src="/images/fb.svg" alt="facebook" className="loginlogos" />
          Facebook
        </a>
      </div>
      <div className="col-lg-4 col-md-12">
        <a
          onClick={() => socialLogin("linkedin")}
          className="btn socialbtn w-100 "
        >
          <img
            src="/images/linked_in.svg"
            alt="linkedin"
            className="loginlogos"
          />
          LinkedIn
        </a>
      </div>
    </div>
  );
}

export default SocialLogin;
